import React, { useState } from "react";
import { RouteComponentProps, Link } from "@reach/router";
import { BasicLayout } from "layouts";
import { FormInput, FormCheckbox, Button } from "components";
import { navigate } from "@reach/router";
import "./style.scss";

export const ForgotPasswordPage: React.FC<RouteComponentProps> = () => {
	const [currentIndex, setCurrentIndex] = useState<number>(-1);
	const [password, setPassword] = useState<string>("");
	const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
		setIsSubmit(true);
		if(password != "") {
			navigate("/new-password");
		}
  };

  return (
    <BasicLayout>
      <form className="login-page-container mt-auto" onSubmit={handleSubmit}>
        <span className="login-page-title">Forgot Password</span>
				<FormInput
					id={0}
          mt={0}
          type="password"
          label="Password"
					isSubmit={isSubmit}
					firstInput={password}
					index={currentIndex}
					error="Password is empty"
					setIndex={() => setCurrentIndex(0)}
					updateFirstInput={(val) => setPassword(val)}
        />
        <Button>Submit</Button>
      </form>
    </BasicLayout>
  );
};
